@if (contentParent != undefined && contentLocation != undefined) {
  <app-content-base [parent]="contentParent" [location]="contentLocation"></app-content-base>
}
